<template>
<span>
<svg  class="svgIconBack" width="19" height="14" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg"
    @click="clicked"
    @mouseout="mouseover"
    @mouseleave="mouseleave"
    @mouseenter="mouseenter"
    @mousedown="mousedown"
>
    <title>Back</title>
    <path d="M8.94603 0.999999C8.94603 0.999999 1.08996 8.14707 1.00001 8.22891L21 8.22891" :stroke="color ? color : 'black'" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8.5 15.4578L0.999996 8.22891" stroke="black" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</span>
</template>
<script>
export default {
    props:["color"],
    methods: {
        clicked() {
            this.$emit('clicked')
        },
        mouseover() {
            this.$emit('mouseover')
        },
        mouseleave() {
            this.$emit('mouseleave')
        },
        mousedown() {
            this.$emit('mousedown')
        },
        mouseenter() {
            this.$emit('mouseenter')
        },
    }
}
</script>
<style >
.svgIconBack{
    cursor:pointer
}
.svgIconBack:hover path {
  stroke: #DA4567;  
}
</style>